import { render, staticRenderFns } from "./AgeRange.vue?vue&type=template&id=963c1d2c&scoped=true&"
import script from "./AgeRange.vue?vue&type=script&lang=js&"
export * from "./AgeRange.vue?vue&type=script&lang=js&"
import style0 from "./AgeRange.vue?vue&type=style&index=0&id=963c1d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963c1d2c",
  null
  
)

export default component.exports